import { api } from './api';

export interface AcceptTermsData {
  latitude?: number;
  longitude?: number;
  city?: string;
  region?: string;
  country?: string;
  userAgent?: string;
}

export interface TermsStatus {
  accepted: boolean;
  acceptedAt: string | null;
}

export interface TermsContract {
  url: string | null;
  fileName: string | null;
}

class TermsService {
  async accept(
    data: AcceptTermsData,
  ): Promise<{ accepted: boolean; acceptedAt: string }> {
    const { data: res } = await api.post('/terms/accept', data);
    return res?.data || res;
  }

  async getStatus(): Promise<TermsStatus> {
    const { data: res } = await api.get('/terms/status');
    return res?.data || res;
  }

  async getContract(): Promise<TermsContract> {
    const { data: res } = await api.get('/terms/contract');
    return res?.data || res;
  }

  async uploadContract(file: File): Promise<TermsContract> {
    const formData = new FormData();
    formData.append('file', file);
    const { data: res } = await api.post('/terms/contract', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res?.data || res;
  }

  async setContractUrl(url: string): Promise<TermsContract> {
    const { data: res } = await api.put('/terms/contract/url', { url });
    return res?.data || res;
  }

  async removeContract(): Promise<{ removed: boolean }> {
    const { data: res } = await api.delete('/terms/contract');
    return res?.data || res;
  }
}

export const termsService = new TermsService();
